import { AskMode } from '@/entities/ask-syncly';

export const QuestionBox = ({ question, mode }: { question: string; mode: AskMode }) => {
  const titleMap = {
    [AskMode.GENERAL]: 'Deep research',
    [AskMode.CONTENT]: 'Content strategy',
  };
  return (
    <div className="bg-base-foreground flex w-fit flex-col gap-1 rounded-lg px-4 py-2.5">
      <span className="text-xs font-medium text-neutral-500">{titleMap[mode]}</span>
      <p className="text-muted text-sm">{question}</p>
    </div>
  );
};
